import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { LatestNews } from "@/components/LatestNews";
import { SwimTravel } from "@/components/SwimTravel";
import { FindYourClub } from "@/components/FindYourClub";
import { Footer } from "@/components/Footer";
import SportsPage from "@/pages/SportsPage";
import SportsArticlePage from "@/pages/SportsArticlePage";
import SportNewsPage from "@/pages/SportNewsPage";
import SportNewsArticlePage from "@/pages/SportNewsArticlePage";
import TravelPage from "@/pages/TravelPage";
import TravelArticlePage from "@/pages/TravelArticlePage";
import InterviewsPage from "@/pages/InterviewsPage";
import InterviewArticlePage from "@/pages/InterviewArticlePage";
import ClubsPage from "@/pages/ClubsPage";
import ClubArticlePage from "@/pages/ClubArticlePage";
import MeetsPage from "@/pages/MeetsPage";
import MeetArticlePage from "@/pages/MeetArticlePage";

const Home = () => {
  return (
    <div data-testid="homepage" className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <LatestNews />
        <SwimTravel />
        <FindYourClub />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sports" element={<SportsPage />} />
          <Route path="/sports/:slug" element={<SportsArticlePage />} />
          <Route path="/sport-news" element={<SportNewsPage />} />
          <Route path="/sport-news/:slug" element={<SportNewsArticlePage />} />
          <Route path="/travel" element={<TravelPage />} />
          <Route path="/travel/:slug" element={<TravelArticlePage />} />
          <Route path="/interviews" element={<InterviewsPage />} />
          <Route path="/interviews/:slug" element={<InterviewArticlePage />} />
          <Route path="/clubs" element={<ClubsPage />} />
          <Route path="/clubs/:slug" element={<ClubArticlePage />} />
          <Route path="/meets" element={<MeetsPage />} />
          <Route path="/meets/:slug" element={<MeetArticlePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
